
const breakpoint = {
    mobileMax: 767,
    desktopMax: 1212,
  }

  export const lightTheme = {
    breakpoint,
    colors: {
      background: "#FBFBFE",
      sectionBackground: "#FFFFFF",
      border: "#D1D5DA4D",
      text: "#252525",
      textSecondary: "#6E7E91",
      linkHoverBlue: "#0F0599",
      linkButtonBlue: "#0366D6",
      tileHoverBlue: "#D4E1F7"
    }
  };
  
  export const darkTheme = {
    breakpoint,
    colors: {
      background: "#252525",
      sectionBackground: "#363636B8",
      border: "#D1D5DA1A",
      text: "#FFFFFF",
      secondaryFont: "#FFFFFF",
      textSecondary: "#FFFFFF",
      linkHoverBlue: "#C9DFF8",
      linkButtonBlue: "#2188FF",
      tileHoverBlue: "#2188FF"
    }
  };